module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-bg1.png?24ffdb89";